export default {
    register: {
        personal_info: "المعلومات الشخصية",
        commercial_info: "المعلومات التجارية",
        account_info: "معلومات الحساب",
        registration_form: "استمارة تسجيل التاجر",
        full_name: "الإسم واللقب*",
        phone_number: "رقم الهاتف*",
        wilaya: "الولاية",
        commune: "البلدية",
        address: "عنوان المحل*",
        business_number: "الرقم التجاري*",
        shop_location: "تحديد موقع المتجر*",
        poster_title: "صور ملصقات قيفتي*",
        shop_title: "صور محلك من الخارج بالكامل*",
        gifty_password: "*كلمة السر الخاصة بتطبيق ڨيفتي",
        confirm_registration: "تأكيد التسجيل",
        verify_phone_number: "التحقق من رقم الهاتف",
        max_photos_upload: "يمكنك رفع ما يصل إلى 3 صور.",
        type: "نوع المحل*",


         placeholders:{
            full_name: "أدخل اسمك الكامل",
            address: "أدخل عنوان محلك",
            business_number: "أدخل رقم السجل التجاري الخاص بك",
            gifty_password : "أدخل كلمة السر الخاصة بتطبيق ڨيفتي",
            location: "حدد موقع محلك على الخريطة",
        },
        phone_rate_limit_exceeded: "لقد تجاوزت عدد المحاولات المسموح بها. يرجى المحاولة لاحقًا",

        location: {
            modal_title: "موقع المحل",
            instructions: "حدد موقع متجرك بالنقر على الخريطة.",
            submit: "حفظ الموقع ",
            cancel: "إلغاء",
        },
        phone_step_description: "الرجاء إدخال رقم هاتفك لبدء عملية التسجيل.",

        errors: {
            phone: "• رقم الهاتف غير صالح",
            server: "• خطأ عند الإتصال بالخادم",
            code: "• الرمز خاطئ",
            file_required: "لم يتم اختيار أي صورة",
            fullname_required: "الاسم الكامل مطلوب.",
            fullname_invalid: "اسم كامل غير صالح.",

            type_required: "نوع المحل مطلوب",
            address_required: "العنوان",
            business_number_required: "الرقم التجاري",
            geolocation_required: "موقع المحل",
            wilaya_required: "الولاية",
            commune_required: "البلدية",
            password_required: "كلمة المرور",
            address_too_short: "العنوان قصير جدًا.",
            address_too_long: "العنوان طويل جدًا.",
        }
        ,
        verification: {
            verification_title: "تأكيد رقم الهاتف",
            description: "الرجاء إدخال الرمز الذي تلقيته عبر رسالة نصية قصيرة.",
            didnt_get_code: "لم تتلقَ الرمز؟",
            resend: "إعادة الإرسال",
            resendIn: "تم إرسال الرمز! يمكن الإرسال من جديد خلال {seconds}ث",
        },
        phone_verification_success: "تم تأكيد رقم الهاتف بنجاح.",

        phone_verification_failed: " فشل التحقق من رقم الهاتف: الرمز غير صحيح",
        registration_success: "تم التسجيل بنجاح",
        registration_failed: "فشل في التسجيل",
        upload_failed: "فشل في تحميل الملفات، حاول مرة أخرى لاحقًا",

        success: {
            main_title: "تم التسجيل بنجاح! مرحبًا بك في",
            description: "اشحن رصيدك في GIFTY وادفع فواتيرك، واشترِ بطاقات التعبئة والاشتراكات وأكثر من 3 ملايين منتج للتجارة الإلكترونية من تطبيق واحد فقط.",
            download: "حمّل التطبيق"
        },

        stepper: {
            phone : "الهاتف",
            verification : "التحقق",
            registration: "التسجيل"
        },
        filePreview:{
            upload: "انقر لتحميل الصور (بحد أقصى 3)"
        }

    }
}